import React, { useEffect } from 'react'
import { BodyText, LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const TargetSavings = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
                This enables Bonpellz users to keep up with their target savings
          </h3>
          <BodyText>
                 with this feature you can add promptly into your savings plan ahead of your actual savings and even for a default month i.e the month you missed and the present month and even add ahead of your savings.

          </BodyText>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8611.svg" alt="couple saving in a bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}